import * as React from "react";
import {useContext, useEffect, useRef, useState} from "react";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import Restaurante from "../../model/Restaurante";
import rest from "../../utils/EnvConfig";
import {ItemEditViewColuna} from "../../component/ItemEditViewColuna";
import Texto from "../../component/form/texto/Texto";
import MoedaBancario from "../../component/form/moeda-bancario/MoedaBancario";
import Switch from "../../component/form/switch/Switch";
import ItemEditView from "../../component/ItemEditView";
import RestauranteCardapioBebidaItem from "../../model/RestauranteCardapioBebidaItem";
import DinheiroUtils from "../../utils/DinheiroUtils";
import ItemEditState from "../../component/ItemEditState";
import EditView from "../../component/EditView";
import RestauranteCardapioBebida from "../../model/RestauranteCardapioBebida";
import {Ajax} from "../../utils/Ajax";
import MultiCombo from "../../component/form/multi-combo/MultiCombo";
import GrupoBebidaSearch from "../../component/form/grupo/GrupoBebidaSearch";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";
import styles from "./Restaurante.module.css";
import {useNavigate} from "react-router-dom";
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";

function RestauranteCardapioBebidaEdit() {
    const {hasRole, user, token} = useKeycloak();
    const [controleSalvamentoAutomatico, setControleSalvamentoAutomatico] = useState(-1);
    const navigate = useNavigate();
    const itensCardapioTitleRef = useRef<any>();
    const cardapioTitleRef = useRef<any>();
    const nomeCardapioRef = useRef<any>();
    const {info, error} = useContext(MensagemContext) as MensagemContextType;
    const [itemEditState] = useState<ItemEditState>(new ItemEditState());
    const [cardapio, setCardapio] = useState<RestauranteCardapioBebida>(new RestauranteCardapioBebida());
    const [cardapioItem, setCardapioItem] = useState<RestauranteCardapioBebidaItem>(new RestauranteCardapioBebidaItem());
    const [restaurantes, setRestaurantes] = useState<Restaurante[]>([]);
    const [statusCardapioBebida, setStatusCardapioBebida] = useState(cardapioItem.status ? cardapioItem.status : true);

    let validacaoNomeCardapioFunction: any;

    useEffect(() => {
        Ajax.of()
            .error(error)
            .setTokenKeycloak(token!)
            .obterTodosCustom(obterRecursoRestaurantesCorreto(), (data) => {
                setRestaurantes(data);
            });
    }, []);

    useEffect(() => {
        setControleSalvamentoAutomatico(prevState => prevState + 1);

        if (!cardapio.id && controleSalvamentoAutomatico >= 0) {
            if (cardapio.itens && cardapio.itens.length !== 0 && !itemEditState.state) {
                salvarCardapio();
            }
        } else if (cardapio.id && controleSalvamentoAutomatico > 0) {
            if (cardapio.itens && cardapio.itens.length !== 0 && !itemEditState.state) {
                salvarCardapio();
            }
        }
    }, [cardapio.itens]);

    useEffect(() => {
        validacaoNomeCardapioFunction = setTimeout(async () => {
            await validarNomeCardapio();
            clearTimeout(validacaoNomeCardapioFunction);
        }, 0);
    }, [cardapio.nomeCardapio, cardapio.restaurantes]);

    const salvarCardapio = async (endLoadingFunc?: () => void) => {
        if (await validar()) {
            await Ajax.of()
                .error(error)
                .setTokenKeycloak(token!)
                .salvarRegistro(`${rest.restauranteCardapioBebida}`,
                    cardapio, (entidade: any) => {
                        cardapio.id = entidade.id;
                        cardapio.uuid = entidade.uuid;
                        info("Cardápio salvo com sucesso");
                        if (endLoadingFunc) endLoadingFunc();
                    }, err => {
                        if (endLoadingFunc) endLoadingFunc();
                    });
        }
    };

    const obterRecursoRestaurantesCorreto = (): string | undefined => {
        if (hasRole(TipoUsuarioKeycloak.ADMIN)) {
            return `${rest.restaurante}/${rest.obterTodos}`;
        }

        if (hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            return `${rest.restaurante}/${rest.restaurantesPorUsuario}${user.id}`;
        }

        return "";
    }

    const cardapioOnChangeHandler = (e: any) => {
        setCardapio({ ...cardapio, [e.target.id]: e.target.value });
    }

    const validarRestauranteCardapioBebidas = (onSuccess: () => void) => {
        if (!cardapioItem.grupo) {
            error("Grupo é obrigatório");
            return;
        }

        if (!cardapioItem.nome) {
            error("Nome do prato é obrigatório");
            return;
        }

        if (!cardapioItem.unidadeMedida) {
            error("Unidade de medida é obrigatório");
            return;
        }

        if (!cardapioItem.valor) {
            error("Valor do prato é obrigatório");
            return;
        }

        onSuccess();
    }

    const adicionarRestauranteCardapioBebidas = () => {
        validarRestauranteCardapioBebidas(() => {
            if (cardapio.itens !== undefined) {
                // TODO Gambiarra, verificar uma forma melhor pra esconder o placeholder para não gerar confusão para o usuário
                if (cardapioItem.observacao && cardapioItem.observacao === " ") {
                    cardapioItem.observacao = cardapioItem.observacao.trim();
                }

                setCardapio({...cardapio, itens: [...cardapio.itens, cardapioItem]});
                setCardapioItem(new RestauranteCardapioBebidaItem());
                setStatusCardapioBebida(true);

                itemEditState.limparState();

                scrollItensCardapioTitle();
            }
        });
    }

    const editarRestauranteCardapioBebidas = (item: RestauranteCardapioBebidaItem) => {
        if (itemEditState.state) {
            error(`Já existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return;
        }

        itemEditState.buildItemState("Cardápio - Bebida", item);

        // TODO Gambiarra, verificar uma forma melhor pra esconder o placeholder para não gerar confusão para o usuário
        if (!item.observacao) {
            item.observacao = " ";
        }

        scrollItensCardapioTitle();

        setCardapioItem(item);
        if (cardapio.itens !== undefined) {
            setCardapio({ ...cardapio, itens: [...cardapio.itens.filter(t => t !== item)] });
        }
    }

    const removerRestauranteCardapioBebidas = (item: RestauranteCardapioBebidaItem) => {
        if (cardapio.itens !== undefined) {
            setCardapio({ ...cardapio, itens: [...cardapio.itens.filter(t => t !== item)] });
        }
    }

    const switchCardapioBebidaOnChangeHandler = (e: any) => {
        setStatusCardapioBebida(e.value);
        setCardapioItem({ ...cardapioItem, status: e.value });
    }

    const cardapioBebidaOnChangeHandler = (e: any) => {
        setCardapioItem({ ...cardapioItem, [e.target.id]: e.target.value });
    }

    const cardapioBebidaMoedaOnChangeHandler = (value: number, valueCorrigido?: number) => {
        setCardapioItem({ ...cardapioItem, valor: valueCorrigido });
    }

    const valorRestauranteCardapioBebidaTemplate = (item: RestauranteCardapioBebidaItem) => {
        if (item.valor) {
            return DinheiroUtils.formatToDinheiro(item.valor);
        }
        return "R$ 0,00";
    };

    const statusRestauranteCardapioBebidaTemplate = (item: RestauranteCardapioBebidaItem) => {
        return item.status ? "Sim" : "Não";
    };
    // ------

    const editEntidade = (data: RestauranteCardapioBebida) => {
        setCardapio(data);
    }

    const validar = async (): Promise<boolean> => {
        if (itemEditState.state) {
            error(`Existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return false;
        }

        if (!cardapio.nomeCardapio) {
            error(`Nome do cardápio é obrigatório`);
            return false;
        }

        if (!cardapio.restaurantes || cardapio.restaurantes.length === 0) {
            error(`Selecione ao menos um restaurante`);
            return false;
        }

        if (cardapio.itens) {
            const itensSemGrupo = cardapio.itens.filter(i => !i.grupo).length;
            if (itensSemGrupo > 0) {
                error(`Existem itens do cardápio sem grupo`);
                return false;
            }
        }

        return true;
    };

    const scrollItensCardapioTitle = () => {
        if (itensCardapioTitleRef.current) {
            itensCardapioTitleRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const scrollCardapioTitle = () => {
        if (cardapioTitleRef.current) {
            cardapioTitleRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const navegarParaFotos = async () => {
        if (await validar()) {
            await Ajax.of()
                .info(info)
                .error(error)
                .setTokenKeycloak(token!)
                .salvarRegistro(`${rest.restauranteCardapioBebida}`, cardapio, (response: any) => {
                    navigate(`/restaurante/cardapio/bebida/imagem/${response.uuid}`);
                }, () => {
                    error("Houve um problema ao tentar salvar.");
                });
        }
    }

    const validarNomeCardapio = async () => {
        if (cardapio.nomeCardapio && cardapio.restaurantes!.length > 0) {
            await Ajax.of()
                .setTokenKeycloak(token!)
                .postRegistroCustom(`${rest.server}${rest.restauranteCardapioBebida}/${rest.cardapiosBebidaValidarNome}`, cardapio, (response: any) => {
                }, (err: Error) => {
                    error(err.message);
                    setCardapio(new RestauranteCardapioBebida());
                    setCardapioItem(new RestauranteCardapioBebidaItem());
                    nomeCardapioRef.current.focus();
                    scrollCardapioTitle();
                });
        }
    }

    const botoesExtra = (entidade: RestauranteCardapioBebidaItem, rowIndex?: number): React.JSX.Element[] => {
        return [
            (
                <>
                    <Button icon={PrimeIcons.CAMERA} className={`${styles.espacamentoBotoes} mr-2`} raised
                            title={"Envio de fotos"} onClick={(event: any) => navegarParaFotos()}
                            severity="success" />
                </>
            )];
    }

    return (
        <>
            <div ref={cardapioTitleRef}></div>
            <EditView title={"Restaurante - Cardápio de bebida"}
                      id={`${rest.restauranteCardapioBebida}`}
                      entidade={cardapio}
                      onValidationHandler={validar}
                      onSalvarHandler={salvarCardapio}
                      sairAoSalvar={false}
                      entidadeUseStateFunction={editEntidade}>

                <Texto id={"nomeCardapio"} label={"* Título do cardápio"} value={cardapio.nomeCardapio} maxLength={20}
                       placeholder={"Ex: Cardápio geral"}
                       size={"100%"} ref={nomeCardapioRef}
                       onChangeHandler={cardapioOnChangeHandler}/>

                <MultiCombo values={restaurantes} id={"restaurantes"}
                            label={"Selecione os restaurantes que desejar usar esse cardápio"}
                            value={cardapio.restaurantes}
                            optionLabel={"nomeEstabelecimento"}
                            onChangeHandler={cardapioOnChangeHandler}/>

                <div ref={itensCardapioTitleRef}></div>
                <ItemEditView id={"restauranteCardapioBebida"}
                              title={"Itens do cardápio"}
                              adicionarFunction={adicionarRestauranteCardapioBebidas}
                              editarItemFunction={editarRestauranteCardapioBebidas}
                              removerItemFunction={removerRestauranteCardapioBebidas}
                              itens={cardapio.itens}
                              botoesAdicionais={botoesExtra}
                              colunas={[
                                  ItemEditViewColuna.of("grupo.nome", "Grupo"),
                                  ItemEditViewColuna.of("nome", "Nome da bebida"),
                                  ItemEditViewColuna.of("unidadeMedida", "Tamanho"),
                                  ItemEditViewColuna.of("valor", "Valor", valorRestauranteCardapioBebidaTemplate),
                                  ItemEditViewColuna.of("status", "Ativo", statusRestauranteCardapioBebidaTemplate)
                              ]}>

                    <div className="formgrid grid">
                        <div className="field col">
                            <GrupoBebidaSearch id={"grupo"} label={"* Grupo"} value={cardapioItem.grupo}
                                               placeholder={"Ex: Sucos"}
                                               fullSize={true} cardapio={cardapio}
                                               maxLength={20}
                                               onChangeHandler={cardapioBebidaOnChangeHandler}
                            />
                        </div>
                        <div className="field col">
                            <Texto id={"nome"} label={"* Nome da bebida"} value={cardapioItem.nome}
                                   maxLength={20} fullSize={true}
                                   placeholder={"Ex: Suco de abacaxi com hortelã"}
                                   onChangeHandler={cardapioBebidaOnChangeHandler}/>
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <Texto id={"unidadeMedida"} label={"* Tamanho"} value={cardapioItem.unidadeMedida}
                                   maxLength={20} fullSize={true}
                                   placeholder={"Ex: Pequeno"}
                                   onChangeHandler={cardapioBebidaOnChangeHandler}/>
                        </div>
                        <div className="field col">
                            <MoedaBancario id={"valor"} label={"* Valor"} value={cardapioItem.valor}
                                           maxLength={999999} fullSize={true}
                                           onValueChangeHandler={cardapioBebidaMoedaOnChangeHandler}/>
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <Texto id={"observacao"} label={"Detalhes"} value={cardapioItem.observacao}
                                   maxLength={100} fullSize={true}
                                   placeholder={"Ex: Suco natural"}
                                   onChangeHandler={cardapioBebidaOnChangeHandler}/>
                        </div>
                        <div className="field col">
                        </div>
                    </div>

                    <Switch checked={statusCardapioBebida} id={"status"}
                            label={statusCardapioBebida ? "Ativo" : "Inativo"}
                            onChangeHandler={switchCardapioBebidaOnChangeHandler}/>

                </ItemEditView>
            </EditView>
        </>
    );
}

export default RestauranteCardapioBebidaEdit;